<div class="row faqRow1">
    <div class="col-12" style="margin: auto; text-align: center;">
      <h1>
        {{labels.lblUnderConstruction}}
      </h1>
    </div>
</div>
